import { render, staticRenderFns } from "./PopupBlock.vue?vue&type=template&id=18cda82b&scoped=true&"
import script from "./PopupBlock.vue?vue&type=script&lang=js&"
export * from "./PopupBlock.vue?vue&type=script&lang=js&"
import style0 from "./PopupBlock.vue?vue&type=style&index=0&id=18cda82b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cda82b",
  null
  
)

export default component.exports